


import { CountryVM } from './CountryVM';
import { Gender } from './Gender';
import { NationalityVM } from './NationalityVM';
export class ClientDetailVM {

  addressLine1?: string;

  addressLine2?: string;

  city?: string;

  country?: CountryVM;

  state?: string;

  county?: string;

  dateOfBirth?: string;

  displayName?: string;

  firstname?: string;

  gender?: Gender;

  hasProfileImage?: boolean;

  lastname?: string;

  mobile?: string;

  nationality?: NationalityVM;

  postcode?: string;

  timeZone?: string;

}
